import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import SEO from '../components/SEO';
import AnimatedSection from '../components/AnimatedSection';
import PageHeader from '../components/PageHeader';
import Sejarah from '../components/Sejarah';

const SejarahPage = () => {
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const docRef = doc(db, 'pageContent', 'tentangKami');
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    setPageData(docSnap.data());
                } else {
                    console.log("No such document!");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <>
            <SEO
                title="Sejarah Singkat - SMK Pariwisata Sumbangsih"
                description="Sejarah berdirinya dan perkembangan SMK Pariwisata Sumbangsih."
            />
            <PageHeader
                title="Sejarah Singkat"
                subtitle="Perjalanan Kami Hingga Kini"
            />
            {loading ? (
                <section className="section">
                    <div className="container" style={{ textAlign: 'center' }}>Memuat konten...</div>
                </section>
            ) : (
                <AnimatedSection>
                    <Sejarah content={pageData} />
                </AnimatedSection>
            )}
        </>
    );
};

export default SejarahPage;
